import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { LoanStore } from '../stores';

export const useLoanStore = () => useContext<{
  loanStore: LoanStore
}>(StoreContext);
